import { render } from "./UnfixeableClaimProductDetails.vue?vue&type=template&id=7c512ebc"
import script from "./UnfixeableClaimProductDetails.vue?vue&type=script&lang=js"
export * from "./UnfixeableClaimProductDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__